import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

export function useStartTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => taskApi.start(id).then((r) => r.data),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(vars.id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      // The calendar reads `GET /schedule`, not the task routes — see useCompleteAppointment.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
